import React from "react";
import { Search } from "lucide-react";

export default function CalendarFilters({
    statuses,
    selectedStatuses,
    onToggleStatus,
    onResetStatuses,
    searchTerm,
    onSearchChange,
    roleConfig,
    directReports,
    selectedCollaboratorId,
    onCollaboratorChange,
    activeView,
    onViewChange,
}) {
    return (
        <div className="calendar-filters">
            <div className="calendar-filters__top-row">
                <div className="calendar-search">
                    <Search size={14} />
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(event) => onSearchChange(event.target.value)}
                        placeholder="Rechercher une session, un lieu..."
                    />
                </div>

                {!!roleConfig.viewOptions?.length && (
                    <div className="calendar-filters__group calendar-filters__group--row">
                        <div className="calendar-filters__chips calendar-filters__chips--views">
                            {roleConfig.viewOptions.map((view) => {
                                const isActive = activeView === view.value;
                                return (
                                    <button
                                        key={view.value}
                                        type="button"
                                        className={`calendar-chip ${isActive ? "is-active" : ""}`}
                                        onClick={() => onViewChange(view.value)}
                                    >
                                        <span>{view.label}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                )}

                <div className="calendar-filters__spacer" />
            </div>

            {roleConfig.isRh && (
                <div className="calendar-filters__bottom-row">
                    <div className="calendar-filters__chips">
                        {statuses.map((status) => {
                            const active = selectedStatuses.includes(status.value);
                            return (
                                <button
                                    key={status.value}
                                    type="button"
                                    className={`calendar-chip ${active ? "is-active" : ""}`}
                                    style={active ? { borderColor: status.borderColor, color: status.color, background: status.background } : undefined}
                                    onClick={() => onToggleStatus(status.value)}
                                >
                                    <span className="calendar-chip__dot" style={{ background: status.borderColor }} />
                                    <span>{status.label}</span>
                                </button>
                            );
                        })}

                        <button type="button" className="calendar-link-btn" onClick={onResetStatuses}>
                            Réinitialiser
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
